var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoloGold1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 240,
    width: 160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "solo_gold_1_svg__a",
    d: "M0 15.043C13.367 5.014 31.419 0 54.155 0s40.787 5.014 54.155 15.043v64.47C91.018 102.504 72.626 114 53.134 114 33.64 114 15.93 102.504 0 79.513z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "solo_gold_1_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#solo_gold_1_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6d5710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 163h58v36l-29 19.44L51 199zM29 54.215C41 46.738 57.833 43 79.5 43S118 46.738 130 54.215l-10 43H39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 82.626C34.774 71.542 54.726 66 79.855 66s45.081 5.542 59.856 16.626v71.257C120.599 179.294 100.27 192 78.727 192c-21.545 0-41.12-12.706-58.727-38.117z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 72)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3c3008",
    xlinkHref: "#solo_gold_1_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.238 112.718l1.028-42.586-2.298-2.014V50.962C44.02 48.527 40.03 48.9 36 52.084s-6.105 6.904-6.224 11.162l-1.838 1.949c-6.4-8.172-9.709-15.773-9.926-22.805-.218-7.032 2.614-14.828 8.495-23.39l3.269 2.212c2.277 4.72 5.196 8.253 8.757 10.602 3.56 2.348 6.706 2.348 9.435 0l2.298-3.395h7.468l2.298 3.395c2.73 2.348 5.875 2.348 9.435 0 3.56-2.349 6.48-5.883 8.757-10.602L81.493 19c5.881 8.562 8.713 16.358 8.495 23.39-.217 7.032-3.526 14.633-9.926 22.805l-1.838-1.95c-.119-4.257-2.194-7.977-6.224-11.16s-8.02-3.558-11.968-1.123v17.156l-2.298 2.014 1.028 42.586L54 119z",
    fill: "#ffe86e",
    mask: "url(#solo_gold_1_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80 8l15 21-15 21-15-21z",
    fill: "#ffe86e"
  }))));
}
export default SvgSoloGold1;